import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getBundleItemProps } from '../utils/get-bundle-item-props.js';
import { BundleLineItem } from './BundleLineItem.js';

var PrescriptionGlassesLineItem = (_param)=>{
    var { lineItem  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "lineItem"
    ]);
    const { getLabel  } = useIntl();
    const { addOn , currency , lensPackage , lensType , prescription , cartDiscount , mainBundleItemPrice ,  } = lineItem;
    const labels = React.useMemo(()=>({
            lensTypeTitle: getLabel(`cart.lineItem.glasses.bundleItem.LensTypes`),
            lensPackageTitle: getLabel(`cart.lineItem.glasses.bundleItem.PrescriptionGlassPackages`),
            addOnTitle: getLabel(`cart.lineItem.glasses.bundleItem.PrescriptionGlassPackageOptions`)
        })
    , [
        getLabel
    ]);
    const addOnConfig = addOn ? getBundleItemProps(addOn, currency, labels.addOnTitle) : undefined;
    const bundleItems = [
        getBundleItemProps(lensType, currency, labels.lensTypeTitle),
        getBundleItemProps(lensPackage, currency, labels.lensPackageTitle), 
    ];
    if (addOnConfig) bundleItems.push(addOnConfig);
    return /*#__PURE__*/ React.createElement(BundleLineItem, swcHelpers.extends({}, rest, {
        lineItem: lineItem,
        bundleItems: bundleItems,
        prescription: prescription,
        cartDiscount: cartDiscount,
        mainBundleItemPrice: mainBundleItemPrice
    }));
};

export { PrescriptionGlassesLineItem };
//# sourceMappingURL=PrescriptionGlassesLineItem.js.map
